// extracted by mini-css-extract-plugin
export var column = "title-module--column--XRyY5";
export var introText = "title-module--intro-text--VjBgk";
export var medium = "title-module--medium--6zRRh";
export var reverse = "title-module--reverse--RZLds";
export var small = "title-module--small--D0blM";
export var title = "title-module--title--ktbK2";